import React, { useEffect } from 'react';
import { TextLarge, TextSmall } from '../../../../components/text';
import { ContainerButton } from '../../../../styles/global-style';
import { useForm } from 'react-hook-form';
import { FORM_CLAIM_NO_APPROVE } from '../form';
import { Spin } from 'antd';
import { ModalTheme } from '../../../../components/modal';
import { RenderForm } from '../../../../components/forms';
import { ButtonTheme } from '../../../../components/buttons';
import { useNoApproveClaim } from '../hooks/useNoApproveClaim';

export const NoApproveClaimModal = ({ open, onToggle, claimData }) => {
  const { control, setValue, getValues, handleSubmit } = useForm({});
  const { mutate: noApproveClaim, loading: isLoadingNoApprove } = useNoApproveClaim();

  const onSubmit = (values) => {
    noApproveClaim(values);
    onToggle({ defaultValue: '' });
  };

  useEffect(() => {
    claimData?.claimId && setValue('claimId', claimData.claimId);
  }, [claimData, setValue]);

  return (
    <Spin spinning={isLoadingNoApprove}>
      <ModalTheme title=" " open={open} onToggle={onToggle}>
        <div style={{ width: '100%', textAlign: 'center' }}>
          <TextLarge text="หมายเหตุ" />
        </div>
        <div style={{ width: '100%', textAlign: 'left' }}>
          <TextSmall text={'ชื่อ : ' + claimData?.fullName} />
          <TextSmall text={'เลขที่เคลม : ' + claimData?.claimCode} />
        </div>
        <RenderForm
          control={control}
          setValue={setValue}
          getValues={getValues}
          forms={FORM_CLAIM_NO_APPROVE()}
        />
        <ContainerButton right>
          <ButtonTheme useFor="SUBMIT" onClick={handleSubmit(onSubmit)} />
          <ButtonTheme useFor="CANCEL" onClick={onToggle} />
        </ContainerButton>
      </ModalTheme>
    </Spin>
  );
};
